import { useState } from 'react';
import { Product } from '../../types/Product';
import { generateMenuPrompt } from '../../utils/grok/prompts';
import { apiService } from '../../services/apiService';
import { useSound } from '../useSound';

export const useGrokMenuGeneration = () => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [menu, setMenu] = useState<string | null>(null);
  const { playSound } = useSound();

  const generateMenu = async (products: Product[], budget: number, dishCount: number) => {
    if (products.length === 0) {
      setError('Necesitas añadir productos a la lista para generar un menú');
      return;
    }

    setIsGenerating(true);
    setError(null);
    setMenu(null);

    try {
      playSound('click');
      const prompt = generateMenuPrompt(products, budget, dishCount);
      const response = await apiService.generateRecipe(prompt);
      setMenu(response.choices[0].message.content);
      playSound('success');
    } catch (err) {
      console.error('Error generating menu:', err);
      setError('Error al generar el menú. Por favor, inténtalo de nuevo.');
      playSound('error');
    } finally {
      setIsGenerating(false);
    }
  };

  return {
    isGenerating,
    error,
    menu,
    generateMenu
  };
};